import { CommonModule } from '@angular/common';
import { EnvironmentProviders, importProvidersFrom, makeEnvironmentProviders } from '@angular/core';
import { GENERAL_CONSTANTS, IHowdenApiInfo } from '@howdeniberia/core-front';
import { CLIENTS_SEARCH_CONSTANTS } from './core/constants/clients-search.constants';
import { IClientsProfileRoutes } from './core/models/gestion-clients-routes';
import { ClientsSearchApiInfo } from './core/services/api/clients-search-api-Info';
import { ClientsContract } from './core/services/api/ida-clients/clients.contract';
import { ClientsService } from './core/services/api/ida-clients/clients.service';
import { ExecutivesContract } from './core/services/api/ida-company/executives.contract';
import { ExecutivesService } from './core/services/api/ida-company/executives.service';
import { OfficesContract } from './core/services/api/ida-company/offices.contract';
import { OfficesService } from './core/services/api/ida-company/offices.service';
import { UsersContract } from './core/services/api/ida-company/users.contract';
import { UsersService } from './core/services/api/ida-company/users.service';
import { ProfessionsContract } from './core/services/api/ida-masters/professions.contract';
import { ProfessionsService } from './core/services/api/ida-masters/professions.service';
import { EventEmitterContract } from './core/services/ui/event-emitter.contract';
import { EventEmitterService } from './core/services/ui/event-emitter.service';

function mergeClientsProfileRoutes(urlsGestionClientes: IClientsProfileRoutes | undefined) {
  if (urlsGestionClientes) {
    if (urlsGestionClientes.local) {
      CLIENTS_SEARCH_CONSTANTS.ClientsProfileRoutes.local = urlsGestionClientes.local;
    }
    if (urlsGestionClientes.development) {
      CLIENTS_SEARCH_CONSTANTS.ClientsProfileRoutes.development = urlsGestionClientes.development;
    }
    if (urlsGestionClientes.staging) {
      CLIENTS_SEARCH_CONSTANTS.ClientsProfileRoutes.staging = urlsGestionClientes.staging;
    }
    if (urlsGestionClientes.production) {
      CLIENTS_SEARCH_CONSTANTS.ClientsProfileRoutes.production = urlsGestionClientes.production;
    }
  }
}

function mergeClientsSearchApiInfo(apiInfo: IHowdenApiInfo[] | undefined): IHowdenApiInfo[] {
  const source: IHowdenApiInfo[] = (apiInfo && apiInfo.length > 0) ? [...apiInfo] : [];
  const names: Set<string> = new Set<string>(source.map(x => x.name));
  const others: IHowdenApiInfo[] = ClientsSearchApiInfo.filter(x => !names.has(x.name));

  return [...source, ...others];
}

export function provideClientSearchLib(
  apiInfo: IHowdenApiInfo[] | undefined = undefined,
  urlsGestionClientes: IClientsProfileRoutes | undefined = undefined
): EnvironmentProviders {
  mergeClientsProfileRoutes(urlsGestionClientes);

  return makeEnvironmentProviders([
    importProvidersFrom([CommonModule]),
    { provide: GENERAL_CONSTANTS.HowdenApiInfoInjectionToken, useValue: mergeClientsSearchApiInfo(apiInfo) },
    { provide: ClientsContract, useClass: ClientsService },
    { provide: ExecutivesContract, useClass: ExecutivesService },
    { provide: OfficesContract, useClass: OfficesService },
    { provide: UsersContract, useClass: UsersService },
    { provide: ProfessionsContract, useClass: ProfessionsService },
    { provide: EventEmitterContract, useClass: EventEmitterService }
  ]);
}